import React from 'react';
import { Tabs } from 'antd';
import classNames from 'classnames';
import Bar from '@/components/charts/bar';
import TitleTag from '@/components/titletag';
import MapChart from '@/components/charts/map';
// import Dot from '@/components/Dot';
import Chart from '@/business-components/chart';
import Tooltip from '@/components/tooltip';
import AmountTag from '@/business-components/amountTag';
import Dot from '@/components/Dot';
import CustomEmpty from '@/business-components/CustomEmpty';
import styles from './index.module.scss';

interface IFinancingScheduleProps {
  data;
  hasUnlock: boolean;
}
const { TabPane } = Tabs;

export default function StoreSituation({ data, hasUnlock }: IFinancingScheduleProps) {
  return (
    <Chart
      title={
        <span className={styles.title}>
          线下门店分布
          <Tooltip
            title={
              <>
                <p>品牌线下门店总数与省市分布情况。数据已脱敏处理。</p>
                <p>数据来源：百炼店店通</p>
              </>
            }
            placement="right"
          />
        </span>
      }
      panelClassName={styles.storeSituationChart}
    >
      {hasUnlock ? (
        <Tabs defaultActiveKey="1">
          <TabPane tab={'线下门店数量'} key={'1'}>
            <div className={classNames('flex-row-nowrap', 'flex-start-start', styles.mapContent)}>
              {data?.brandStoreCityList?.map((item, index) => (
                <div className={styles.mapItem} key={index}>
                  <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.titleTag)}>
                    <TitleTag style={{ marginBottom: 0 }}>{item?.chName}</TitleTag>
                    <AmountTag
                      className={styles.amountTag}
                      title={'线下门店数量'}
                      amount={
                        !item?.storeTotalNum ? (
                          <span className={styles.emptyStateText}>暂无数据</span>
                        ) : (
                          item?.storeTotalNum
                        )
                      }
                    />
                  </div>
                  {!item?.storeTotalNum ? (
                    <CustomEmpty />
                  ) : (
                    <MapChart data={item?.list ?? []} tooltipName="线下门店数量" height={224} />
                  )}
                </div>
              ))}
            </div>
          </TabPane>
          <TabPane tab={'线下门店分布TOP5省市'} key={'2'}>
            <div className={classNames('flex-row-nowrap', 'flex-start-start', styles.mapContent)}>
              {data?.brandStoreChartsList?.map((item, index) => (
                <div className={styles.mapItem} key={index}>
                  <div
                    className={classNames('flex-row-nowrap', 'flex-start-center')}
                    style={{ margin: '0 0 20px 20px' }}
                  >
                    <Dot style={{ marginRight: '4px' }} />
                    {item?.chName}
                  </div>
                  {!item?.storeTotalNum ? (
                    <CustomEmpty />
                  ) : (
                    <Bar
                      height={224}
                      data={item?.list || []}
                      xField="province"
                      yField="storeNum"
                      tooltipName="线下门店数"
                      padding={[20, 50]}
                    />
                  )}
                </div>
              ))}
            </div>
          </TabPane>
        </Tabs>
      ) : (
        <CustomEmpty text="已选择的品牌中有未解锁的品牌，请解锁后查看" />
      )}
    </Chart>
  );
}
